// import { TENANT_ID_MAP, getTenantId } from '@/utils/index'
import { StoreUtils } from '@/store/StoreUtil'

export const config = {
  bodyWidth: 1310
}

export const CERTIFICATION_TYPE = {
  hsc: '1',
  gsc: '0'
}

export const TEACHING_TYPE: Record<string, string> = {
  onsite: '0',
  online: '1'
}

export const USER_ENROLL_STATUS = {
  enroll: '0',
  pending: '1',
  unenroll: '3',
  viewEnrollment: '2',
  checkin: '4',
  absent: '5',
  finished: '6'
}

export const RELATION_TYPE: Record<string, string> = {
  // 测试
  quiz: '1',
  // 理论考试
  exam: '0'
}

/*
  200: 成功，400：参数校验失败，401：未登录，403：拒绝访问，404：页面不存在，500：失败，200001：远程调用失败
*/
export const CODES = {
  SUCCESS: 200,
  VALIDATE_FAILED: 400,
  NEED_LOGIN: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  FAILED: 500,
  OTHER_ERROR: 501,
  REMOTE_ERROR: 200001,
  EXAM_FETCH_ERROR: 30000,
  SUBMIT_ANSWER_ERROR: 30001,
  ADD_USER_ERROR: 30002,
  UPDATE_EXAM_ERROR: 30003
}

// 海康的报错信息
export const codeMessageList = [
  { code: CODES.VALIDATE_FAILED, message: 'error.400' },
  // { code: CODES.FORBIDDEN, message: 'Request Method Anomaly' },
  { code: CODES.FORBIDDEN, message: 'error.403' },
  { code: CODES.OTHER_ERROR, message: '' },
  { code: CODES.FAILED, message: 'error.500' },
  { code: CODES.REMOTE_ERROR, message: 'error.200001' },
  { code: CODES.EXAM_FETCH_ERROR, message: 'error.30000' },
  { code: CODES.SUBMIT_ANSWER_ERROR, message: 'error.30001' },
  { code: CODES.ADD_USER_ERROR, message: 'error.30002' },
  { code: CODES.UPDATE_EXAM_ERROR, message: 'error.30003' }
]

export function setCodeMessage (code: number, msg: string) {
  if (code === CODES.OTHER_ERROR) {
    return msg
  }
  const store = StoreUtils.store
  const messageObj = codeMessageList.find(el => code === el.code)
  let message = ''
  if (messageObj) {
    message = messageObj.message
  } else {
    message = `error.${code}`
  }
  const i18nContent = store?.state?.global.messages?.en?.[message]
  return i18nContent || msg || 'System Error'
}

export const SOCIAL_SITE_URLS = {
  twitter: 'https://twitter.com/HikvisionHQ',
  linkedIn: 'https://www.linkedin.com/company/hikvision',
  youtube: 'https://www.youtube.com/channel/UCAt5uHvm5r71kxgm3SYyoPw',
  facebook: 'https://www.facebook.com/HikvisionHQ/',
  instagram: 'https://www.instagram.com/hikvision/',
  chat: 'https://international-chat.hikvision.com/webchat/index.html?appKey=af90eed80113af969375513b8b4fae59##msg18'
}

// 立陶宛、爱沙尼亚、拉脱维亚的用户访问时，要展示rejectAll；并且cookie开关默认关闭
export const STRICT_COOKIE_POLICY_CONTRIES = ['LT', 'EE', 'LV']

export const IN_ENROLL_DIALOG_TYPE = {
  enrollWithInvitationCode: '0',
  enrollWithCodeAndPracticalExam: '1',
  defaultBindsPracticalExam: '2',
  default: '3'
}

export const ENROLL_RELATION_TYPE: Record<string, string> = {
  classroom: '0',
  certification: '1'
}

export const IN_ENROLL_DIALOG_ENTRY: Record<string, string> = {
  classroom: '0',
  certification: '1',
  course: '2'
}

export const COUNTRY_QUERY_TYPE = {
  all: 0
}
